<script setup lang="ts">
import { useAppStore } from '../store'
const store = useAppStore()
</script>

<template>
  <!-- A correction the reader set days ago must never quietly flatter a depth -->
  <router-link v-if="store.settings.surge" to="/instellingen" class="surgechip">
    {{ store.settings.surge > 0 ? '+' : '−' }}{{ Math.abs(store.settings.surge / 100).toFixed(2) }} m
  </router-link>
  <!-- views of the same place, the way the old app tabs a location. Drying out is left out
       for a bridge: taking the ground under one is not a question anybody asks. -->
  <nav class="placetabs">
    <router-link to="/">{{ store.t('tide') }}</router-link>
    <router-link v-if="!store.bridge" to="/droogvallen">{{ store.t('dryingOut') }}</router-link>
    <router-link to="/info">{{ store.t('info') }}</router-link>
  </nav>
</template>
